import * as Sentry from '@sentry/react';

export const logError = (err, messageOrTags, extras) => {
  const tags = typeof messageOrTags === 'string' ? { message: messageOrTags } : messageOrTags;

  const errorArray = ['logError:', err, tags, extras].filter(Boolean);
  console.error(...errorArray);
  Sentry.withScope((scope) => {
    scope.setTag('URL', document.location.href);
    if (tags) {
      Object.keys(tags).forEach((key) => {
        scope.setTag(key, tags[key]);
      });
    }
    if (extras) {
      Object.keys(extras).forEach((key) => {
        scope.setExtra(key, extras[key]);
      });
    }
    Sentry.captureException(err);
  });
};
